import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { ID } from 'types/common'

import * as apiUtils from '.'

const url = '/omnidots'

export const getListSensors = (measuringPointId: number) =>
  apiUtils.GET(`${url}/get-list-sensors`, {
    params: { measuringPointId },
  })

export const getPeakRecords = (measuringPointId: number) =>
  apiUtils.GET(`${url}/get-peak-records`, { params: { measuringPointId } })

export const cycleHistogram = (
  siteId: ID,
  params: { 'epoch.start'?: number; 'epoch.end'?: number } = {},
  options: AxiosRequestConfig = {},
) =>
  apiUtils.GET(
    `${url}/cycle-histogram`,
    merge({ params: { 'site.id': siteId, ...params } }, options),
  )

export type MeasuringPointEntry = {
  id: number
  name: string
  sensorName: string
  online: boolean
}

export const getMeasuringPoints = (): Promise<{
  measuringPoints: MeasuringPointEntry[]
}> => apiUtils.GET(`${url}/measuring-points`)
